module.exports = __webpack_public_path__ + "media/bootstrap-icons/tablet-8c9328b9.svg";